/**
 * FogOfWarState.ts — Tracks which locations have been discovered.
 *
 * Ported from RotaryKnights. Locations start hidden (fog) and become
 * discovered when visited or revealed by story events.
 */

export class FogOfWarState {
  private discovered: Set<string>;

  constructor(initialDiscovered?: string[]) {
    this.discovered = new Set(initialDiscovered ?? []);
  }

  /** Discover a location (make it visible on the map). */
  discover(locationId: string): boolean {
    if (this.discovered.has(locationId)) return false;
    this.discovered.add(locationId);
    return true;
  }

  /** Check if a location has been discovered. */
  isDiscovered(locationId: string): boolean {
    return this.discovered.has(locationId);
  }

  /** Get all discovered location IDs. */
  getDiscovered(): string[] {
    return Array.from(this.discovered);
  }

  /** Get the count of discovered locations. */
  getDiscoveredCount(): number {
    return this.discovered.size;
  }

  /** Serialize to array for save/load. */
  serialize(): string[] {
    return Array.from(this.discovered);
  }

  /** Create from serialized data. */
  static deserialize(data: string[]): FogOfWarState {
    return new FogOfWarState(data);
  }
}
